import { useCallback, useMemo } from "react";
import { TPatientSchedulingItem } from "src/components/patients/scheduling/types";

interface IProps {
    item: TPatientSchedulingItem;
    selected: boolean;
    setSelected: (i: TPatientSchedulingItem | null) => void;
    disabled?: boolean;
    children: React.ReactNode[] | React.ReactNode;
}

const PatientSchedulingCard: React.FC<IProps> = ({
    item,
    selected,
    setSelected,
    disabled,
    children,
}) => {
    const klass = useMemo(() => {
        const base = `my-3 p-3 shadow border rounded ${disabled ? "border-secondary" : "pointer"}`;
        if (selected && !disabled) {
            return `${base} border-primary`;
        } else {
            return base;
        }
    }, [selected, disabled]);

    const firstChild = useMemo(
        () => (children && children[0] ? children[0] : children),
        [children],
    );
    const lastChild = useMemo(() => (children && children[1] ? children[1] : null), [children]);

    const handleSelect = useCallback(() => {
        if (!disabled) {
            setSelected(selected ? null : item);
        }
    }, [disabled, selected, item, setSelected]);

    return (
        <div className={klass} onClick={handleSelect}>
            <div className="col">
                {firstChild}
                <div className="row mt-2">
                    <div className="col body-small gray2 bold">{lastChild}</div>
                </div>
            </div>
        </div>
    );
};

export default PatientSchedulingCard;
